export default "__VITE_PUBLIC_ASSET__7d8c77ff__"